module.exports = __webpack_public_path__ + "sms-icon.png?ae540c0cefb85eb338c2a72dfd137808";